import { mapGetters } from 'vuex'

export const missionInProgressMixin = {
  data() {
    return {
      tempDataModifying: {},
      typingDelay: false
    }
  },
  computed: {
    ...mapGetters(['pusherRef']),
    ...mapGetters({
      user: 'auth/getProfile'
    })
  },
  methods: {
    triggerActionBlock(data, value) {
      // console.log('triggerActionBlock', data, value)
      let actions = {
        delete: false,
        modify: false,
        terminate: false,
        whereEditable: false
      }
      if (!value) actions = data.actions
      const channel = this.pusherRef.channels.channels['presence-action-in-mission-in-progress']
      // console.log('pusherRef', this.pusherRef)
      channel.trigger(
        'client-action-in-mission-in-progress',
        {
          i: data.missionID,
          a: actions,
          v: value,
          u: this.user.name
        }
      )
    },
    changeAction() {
      const actions = {
        delete: false,
        modify: false,
        terminate: false,
        whereEditable: false
      }
      const channel = this.pusherRef.channels.channels['presence-action-in-mission-in-progress']
      channel.trigger(
        'client-action-in-mission-in-progress',
        {
          i: this.tempDataModifying.missionID,
          a: actions,
          v: false,
          u: ''
        }
      )
    },
    textInputAction() {
      if (!this.typingDelay) {
        this.changeAction()
        this.typingDelay = true
        setTimeout(() => {
          this.typingDelay = false
        }, 2000)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/missionInProgressMixin.js